//113
import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import { CushionMaterial, PaintColorMaterial } from '../../utils/materials';

export function Boothbay_dining_chair_painted(props) {
  const { nodes, materials, scene } = useGLTF(
    'models/Boothbay Dining Chair - Painted.glb',
  );

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-boothbay_dining_chair_painted-paint_color',
    aoIntensity,
  );
  useSetMaterialFinish(
    CushionMaterial,
    currentMaterialFinish.cushionFinish,
    defaultFinish.cushionFinish,
    'ao-boothbay_dining_chair_painted-cushion',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      {currentFinishes.cushionFinish !== 'No Cushion' ? (
        <>
          <mesh
            castShadow
            geometry={nodes.Cushion.geometry}
            material={CushionMaterial}
          />
          <mesh
            castShadow
            geometry={nodes.Stiches.geometry}
            material={materials.Stiches}
          />
          <mesh
            castShadow
            geometry={nodes.Ziper.geometry}
            material={materials.Ziper}
          />
        </>
      ) : null}
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      <Shadow model={'Boothbay Dining Chair - Painted'} />
    </group>
  );
}
